import { AwardsScreenShapes } from 'components/customers/models/Award';
import { Option } from 'lib/types';

export const weekdays: Option[] = [
    {
        value: '1',
        label: 'Monday'
    },
    {
        value: '2',
        label: 'Tuesday'
    },
    {
        value: '4',
        label: 'Wednesday'
    },
    {
        value: '8',
        label: 'Thursday'
    },
    {
        value: '16',
        label: 'Friday'
    },
    {
        value: '32',
        label: 'Saturday'
    },
    {
        value: '64',
        label: 'Sunday'
    }
];

export const awardBackgroundSizes = (awardShape?: AwardsScreenShapes) => {
    switch (awardShape) {
        case AwardsScreenShapes.SINGLE_RECTANGLE:
            return {
                ratio: 3 / 1,
                description: '600px by 200px. Max. file size is 1M.'
            };
        case AwardsScreenShapes.LARGE_SQUARE:
        case AwardsScreenShapes.SMALL_SQUARE:
            return {
                ratio: 1 / 1,
                description: '400px by 400px. Max. file size is 1M.'
            };
        case AwardsScreenShapes.DOUBLE_RECTANGLE:
        default:
            return {
                ratio: 3 / 2,
                description: '600px by 400px. Max. file size is 1M.'
            };
    }
};

export const awardsScreenShapeOptions: Option[] = [
    {
        value: AwardsScreenShapes.DOUBLE_RECTANGLE,
        label: 'Double Rectangle'
    },
    {
        value: AwardsScreenShapes.SINGLE_RECTANGLE,
        label: 'Single Rectangle'
    },
    {
        value: AwardsScreenShapes.LARGE_SQUARE,
        label: 'Large Square'
    },
    {
        label: 'Small Square',
        value: AwardsScreenShapes.SMALL_SQUARE
    }
];
